import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useNavigate } from 'react-router-dom';
import { compose } from 'redux';
import { Badge, CTA, HtmlRaw, Text } from '../../../../ui/atoms';
import {
  Wrapper,
  CourseListContainer,
  PageGrid,
  Title,
  CategoryCard,
  CategoriesWrapper,
  PageWrapper,
} from '../style';
import routes from '../../../../routes';
import { COURSE_LIST_RESET } from '../../../redux/actions/courselist';
import { Container } from '../../../../ui/gridSystem';
import { withMediaQueries } from '../../../hoc/withMediaQueries';
import { StickyFiltersWrapper } from '../../../../ui/atoms/CTA/style';
import { MODAL_OPEN } from '../../../redux/actions';
import ModalCategories, {
  ModalCategoriesId,
} from '../../../../ui/atoms/Modals/ModalCategories';
import CourseResults from '../CourseResults';
import Tabs from '../../../../ui/atoms/Tabs';
import ModuleResults from '../ModuleResults';
import EventResults from '../EventResults';

const defaultTabs = [
  { value: 'courses', label: 'Corsi' },
  { value: 'modules', label: 'Moduli' },
  { value: 'events', label: 'Eventi' },
];

const CourseListNational = ({
  mediaIsPhone,
  currentCatalog,
  categories,
  courseListReset,
  modalOpen,
  coursePager,
  modulePager,
  eventPager,
  menuLinks,
  currentPath,
}) => {
  const navigate = useNavigate();
  const [currentArea, setCurrentArea] = useState({});
  // tabs
  const [tabs, setTabs] = useState(defaultTabs);
  const [activeTab, setActiveTab] = useState(defaultTabs[0]);

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      courseListReset();
      setCurrentArea({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const newTabs = [...defaultTabs];
    newTabs[0].items = coursePager?.total_items ?? 0;
    newTabs[1].items = modulePager?.total_items ?? 0;
    newTabs[2].items = eventPager?.total_items ?? 0;
    setTabs(newTabs);
  }, [coursePager, modulePager, eventPager]);

  const onClickCategory = (c) => {
    if (currentArea.id === c.id) setCurrentArea({});
    else setCurrentArea(c);
  };

  return (
    <>
      <Container>
        <Title>
          <Text type="h1" mb={mediaIsPhone ? 20 : 0}>
            {
              menuLinks.find((link) =>
                link?.data?.path?.includes(currentPath?.split('/')[3])
              )?.data?.text
            }
          </Text>
          <CTA
            onClick={() => navigate(`${routes.catalog.path}/locale`)}
            btnText="vai alla formazione locale"
            type="tertiary"
            icon="arrow-narrow-right"
            bottomRight={!mediaIsPhone}
          />
        </Title>
        <PageGrid>
          {mediaIsPhone ? (
            <StickyFiltersWrapper mb={16}>
              <CTA
                btnText="CAMBIA AREA TEMATICA"
                fullsize
                onClick={() =>
                  modalOpen(ModalCategoriesId, {
                    categories,
                  })
                }
              />
            </StickyFiltersWrapper>
          ) : (
            <div>
              <Text type="h2" className="pb-3 category-title">
                Area tematica
              </Text>
              <CategoriesWrapper>
                {(categories || []).map((c) => {
                  if (!c.coursesByCategory) return null;
                  return (
                    <CategoryCard
                      key={`category-${c?.id}`}
                      onClick={() => onClickCategory(c)}
                      className={currentArea.id === c?.id ? 'active' : ''}
                    >
                      <Text type="b3" className="label">
                        {c.label}
                      </Text>
                      {c?.coursesByCategory && (
                        <Badge
                          type="counter"
                          active={currentArea.id === c?.id}
                          notification={c?.hasNewCourses}
                        >
                          {c.coursesByCategory}
                        </Badge>
                      )}
                    </CategoryCard>
                  );
                })}
              </CategoriesWrapper>
            </div>
          )}
          <CourseListContainer>
            <Wrapper>
              <Text type="h1.5" mb={16}>
                {currentArea.label ?? 'Tutti i corsi'}
              </Text>
              <Text type="b3" mb={48}>
                <HtmlRaw html={currentArea?.description || ''} />
              </Text>
              <Tabs
                tabs={tabs}
                selected={activeTab}
                onChange={(tab) => {
                  setActiveTab(tab);
                }}
              />
              <PageWrapper
                className={activeTab?.value === 'courses' ? 'active' : ''}
              >
                <CourseResults
                  currentCatalog={currentCatalog}
                  currentArea={currentArea}
                  active={activeTab?.value === 'courses'}
                />
              </PageWrapper>
              <PageWrapper
                className={activeTab?.value === 'modules' ? 'active' : ''}
              >
                <ModuleResults
                  currentCatalog={currentCatalog}
                  currentArea={currentArea}
                  active={activeTab?.value === 'modules'}
                />
              </PageWrapper>
              <PageWrapper
                className={activeTab?.value === 'events' ? 'active' : ''}
              >
                <EventResults
                  currentCatalog={currentCatalog}
                  currentArea={currentArea}
                  active={activeTab?.value === 'events'}
                />
              </PageWrapper>
            </Wrapper>
          </CourseListContainer>
        </PageGrid>
      </Container>
      {mediaIsPhone && (
        <ModalCategories
          onClick={(category = {}) => setCurrentArea(category)}
        />
      )}
    </>
  );
};

CourseListNational.propTypes = {
  mediaIsPhone: PropTypes.bool,
  currentCatalog: PropTypes.object,
  currentPath: PropTypes.string,
  menuLinks: PropTypes.array,
  // HOC (connect, state)
  coursePager: PropTypes.object.isRequired,
  modulePager: PropTypes.object.isRequired,
  eventPager: PropTypes.object.isRequired,
  categories: PropTypes.array,
  // HOC (connect, dispatch)
  courseListReset: PropTypes.func.isRequired,
  modalOpen: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const {
        courses: { pager: coursePager },
        modules: { pager: modulePager },
        events: { pager: eventPager },
        categories,
      } = state.courselist;
      const { menuLinks } = state.home;
      return {
        coursePager,
        modulePager,
        eventPager,
        categories,
        menuLinks,
      };
    },
    (dispatch) => ({
      courseListReset: () => dispatch({ type: COURSE_LIST_RESET }),
      modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
    })
  ),
  withMediaQueries
)(CourseListNational);
